import React from 'react';

import { IFrameOverlay } from '@candu-ai/document/preview';

interface IFramePreviewProps {
  src: string;
}

export const IFramePreview = ({ src }: IFramePreviewProps) => {
  return (
    <>
      <IFrameOverlay />
      <iframe
        title={`Embedded content, url: ${src}`}
        style={{ pointerEvents: 'none' }}
        src={src}
        width="100%"
        height="100%"
        frameBorder="0"
        marginHeight={0}
        marginWidth={0}
      />
    </>
  );
};
